import React from 'react'
import { useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const WorstTournamentIcon: React.FC<IIconProps> = (props) => {
  const theme = useTheme()
  return (
    <svg
      version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px'
      width={props.width} height={props.width} viewBox='0 0 31.953 31.953' fill={theme.palette.text.primary}
    >
      <g>
        <g>
          <rect x='5.174' y='19.758' width={props.width} height={props.width} fill={theme.palette.text.primary} />
          <circle cx='22.557' cy='3.928' r='3.928' />
          <path
            d='M25.173,27.842V15.693L23.05,15.66l0.783-7.456l-1.97,0.119l-0.299,3.716l-1.854-4.52l-4.365-0.553l-1.632,11.739l8.21,0.102l0.037,9.035l0,0v1.506h4.818v-1.506H25.173z M20.336,15.674l-0.01,0.02h-0.795l0.074-3.43l1.193,3.41H20.336z'
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>

  )
}
export default WorstTournamentIcon
